import { render } from "./DrawingList.vue?vue&type=template&id=346fd5d2&scoped=true"
import script from "./DrawingList.vue?vue&type=script&lang=js"
export * from "./DrawingList.vue?vue&type=script&lang=js"

import "./DrawingList.vue?vue&type=style&index=0&id=346fd5d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346fd5d2"]])

export default __exports__